import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { browserHistory } from 'react-router';

import NotYouDetailsModal from '../NotYouDetailsModal';
import PostMessageModal from '../PostMessageModal';
import AnonymousDetailsModal from '../AnonymousDetailsModal';
// import ConfirmPinModal from '../ConfirmPinModal';
import AddPhoneModal from '../AddPhoneModal';
import MessagePostedModal from '../MessagePostedModal';
import LoginModal from '../LoginModal';
import { getBaseRoute } from '../WebCommunity';

import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';
import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

const { loginById } = authUserOperations;
const { stageMessageValues } = webCommunityOperations;

const ModalDispatcher = ({ location, routeParams }) => {
  const { modalName } = routeParams;
  const { query, pathname, state } = location || {};
  const { userId: queryUserId, message: prepopulatedCondolence } = query;
  const baseRoute = getBaseRoute(pathname);
  const dispatch = useDispatch();

  const [initialCondolence] = useState(prepopulatedCondolence);

  const handleCloseModal = () => {
    browserHistory.push({ pathname: baseRoute });
  };

  // log user in and save pre filled message if url params exist
  useEffect(() => {
    if (queryUserId) {
      dispatch(loginById(queryUserId));
      dispatch(stageMessageValues({ loginById: true }));
      browserHistory.push({ pathname });
    }
  }, [dispatch, pathname, queryUserId]);

  const renderModal = modalName => {
    const modalProps = {
      baseRoute,
      closeModal: handleCloseModal,
      initialCondolence,
      pendingComment: state?.pendingComment
    };
    switch (modalName) {
      case 'create-user':
        return <NotYouDetailsModal {...modalProps} />;
      case 'create':
        return <PostMessageModal {...modalProps} />;
      case 'guest-details':
        return <AnonymousDetailsModal {...modalProps} />;
      case 'add-phone':
        return <AddPhoneModal {...modalProps} />;
      // case 'confirm-pin':
      //   return <ConfirmPinModal {...modalProps} />;
      case 'message-posted':
        return <MessagePostedModal {...modalProps} />;
      case 'login':
        return <LoginModal {...modalProps} />;
      default:
        return null;
    }
  };

  return renderModal(modalName);
};

export default ModalDispatcher;
